const DEVICE_ID_KEY = "tb_web_device_id_v1";

function storedDeviceId(value) {
  const normalized = typeof value === "string" ? value.trim() : "";
  return normalized.length >= 8 && normalized.length <= 128 ? normalized : null;
}

function secureRandomId(webCrypto) {
  if (typeof webCrypto?.randomUUID === "function") {
    return webCrypto.randomUUID();
  }
  if (typeof webCrypto?.getRandomValues === "function") {
    const bytes = webCrypto.getRandomValues(new Uint8Array(16));
    return Array.from(bytes, (value) => value.toString(16).padStart(2, "0")).join("");
  }
  const error = new Error("web_crypto_unavailable");
  error.code = "web_crypto_unavailable";
  throw error;
}

export function createWebDeviceIdResolver({
  storageProvider = () => globalThis.localStorage,
  webCrypto = globalThis.crypto,
} = {}) {
  let memoryDeviceId = null;

  return function getStableWebDeviceId() {
    if (memoryDeviceId) return memoryDeviceId;

    let storage = null;
    try {
      storage = storageProvider();
      const existing = storedDeviceId(storage?.getItem(DEVICE_ID_KEY));
      if (existing) {
        memoryDeviceId = existing;
        return memoryDeviceId;
      }
    } catch {
      storage = null;
    }

    const randomId = secureRandomId(webCrypto);
    const persistedCandidate = `web-${randomId}`;
    if (storage) {
      try {
        storage.setItem(DEVICE_ID_KEY, persistedCandidate);
        memoryDeviceId = persistedCandidate;
        return memoryDeviceId;
      } catch {
        /* The in-memory ID below remains stable for this page lifetime. */
      }
    }
    memoryDeviceId = `web-anon-${randomId}`;
    return memoryDeviceId;
  };
}

const resolveDefaultWebDeviceId = createWebDeviceIdResolver();

export function getWebDeviceId() {
  return resolveDefaultWebDeviceId();
}

export function createWebIdempotencyKey(webCrypto = globalThis.crypto) {
  return secureRandomId(webCrypto);
}

export const createWebRegistrationAttemptId = createWebIdempotencyKey;
